import React, { useMemo, useState } from "react";
import {
  UNAUTHORIZED_LINK_EXPIRY_CONTENT,
  UNAUTHORIZED_LINK_EXPIRY_HEADER,
  UNAUTHORIZED_SOMETHING_WENT_WRONG_HEADER,
  UNAUTHORIZED_SOMETHING_WENT_WRONG_CONTENT,
  UNAUTHORIZED_NO_DATA_HEADER,
  UNAUTHORIZED_NO_DATA_CONTENT,
} from "../../constants";
import ErrorPopover from "./components/PopoverContainer";
import { RootState } from "store";
import { useAppSelector, useTokenAuth } from "hooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ErrorContent, ErrorType } from "type";

const Unauthorized: React.FC = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const shareIdFromStore = useAppSelector(
    (state: RootState) => state?.share?.shareId
  );
  const apiError = useAppSelector((state: RootState) => state?.share?.apiError);
  const apiErrorType = useAppSelector(
    (state: RootState) => state?.share?.apiErrorType
  );
  const shareIdFromUrl = searchParams.get("id");
  const { errorType } = useTokenAuth();
  const shareId = shareIdFromUrl || shareIdFromStore;

  // Determine error content based on error type
  const errorContent = useMemo((): ErrorContent => {
    switch (apiErrorType || errorType) {
      case ErrorType.EXPIRED:
        return {
          title: UNAUTHORIZED_LINK_EXPIRY_HEADER,
          content: UNAUTHORIZED_LINK_EXPIRY_CONTENT,
        };

      case ErrorType.NOT_FOUND:
        return {
          title: UNAUTHORIZED_NO_DATA_HEADER,
          content: UNAUTHORIZED_NO_DATA_CONTENT,
        };

      case ErrorType.FUTURE:
        return {
          title: "Link Not Active",
          content:
            "This sharing link is not yet active. Please try again later.",
        };

      case ErrorType.NETWORK:
        return {
          title: UNAUTHORIZED_SOMETHING_WENT_WRONG_HEADER,
          content:
            "Unable to connect to the server. Please check your internet connection and try again.",
        };

      case ErrorType.UNKNOWN:
      default:
        return {
          title: UNAUTHORIZED_NO_DATA_HEADER,
          content: apiError || UNAUTHORIZED_SOMETHING_WENT_WRONG_CONTENT,
        };
    }
  }, [errorType]);

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  const handleRetry = () => {
    navigate(`/track/share?id=${shareId}`, { replace: true });
  };

  return (
    <>
      <ErrorPopover
        isOpen={isPopoverOpen}
        onClose={handleClose}
        onRetry={handleRetry}
        title={errorContent.title}
        content={errorContent.content}
      />
    </>
  );
};

export default Unauthorized;
